// extracted by mini-css-extract-plugin
export default {"runAnalysisModal":"h9g4L","supportLink":"CCkvQ","btnShare":"qVjVc","openNew":"yxIh5"};